import { types } from 'mobx-state-tree';

export const StatusSelect = types.model({}).actions(self => ({
  toggleSellectAllStatuses(listLength) {
    if (self.statuses.length === listLength) {
      self.statuses = [];
    } else {
      self.statuses = self.statusList.map(({ status }) => status);
    }
  },
  selectStatus(status) {
    const exist = self.statusesObj[status] !== undefined;
    if (exist) {
      self.removeStatus(status);
    } else {
      self.setStatus(status);
    }
  },
  removeStatus(status) {
    self.statuses = [...self.statuses].filter(s => s !== status);
  },
  setStatus(status) {
    self.statuses = [...self.statuses, status];
  },
}));

export default StatusSelect;
